import { Icon } from "ui/gluestack/icon";
import { Link, LinkText } from "ui/gluestack/link";

interface Props {
  icon?: React.ElementType;
  label: string;
  path: string;
  active?: boolean;
}
export function NavigationMenuItem({ icon, label, path, active }: Props) {
  return (
    <Link href={path} className="flex flex-row gap-4 items-center group">
      {icon ? (
        <Icon
          as={icon}
          className={`group-hover:stroke-primary-500 group-hover:fill-primary-500 ${active ? "stroke-primary-500 fill-primary-500" : "stroke-secondary-500 fill-secondary-500"}`}
          size="lg"
        />
      ) : null}
      <LinkText
        className={`no-underline text-text-900 ${active ? "font-semibold" : ""}`}
      >
        {label}
      </LinkText>
    </Link>
  );
}
